// extracted by mini-css-extract-plugin
export var clips = "index-module--clips--2r7xT";
export var clipsContainer = "index-module--clips-container--73EBx";
export var clip1 = "index-module--clip-1--obUQn";
export var clip2 = "index-module--clip-2--fPXxE";